<template>
  <div>
    <Head></Head>
    <div class="number">
      <h3>服务平台招聘岗位报名人数统计</h3>
      <div class="number_box">
        <table border="1">
          <tr>
            <th>招聘单位</th>
            <th>招聘岗位</th>
            <th>岗位代码</th>
            <th>招聘人数</th>
            <th>报考人数</th>
            <th>合格人数</th>
            <th>缴费人数</th>
            <th>操作</th>
          </tr>
          <tr v-for="(item, index) in list" :key="index">
            <td>
              <div class="td_gg" :title="item.news_releases.name">
                <a :href="'/#/Article?id='+item.news_releases.id">{{ item.news_releases.name }}</a>
              </div>
            </td>
            <td :title="item.name">{{ item.name }}</td>
            <td>{{ item.code }}</td>
            <td>{{ item.rec_people_num }}</td>
            <td>{{ item.sign_up_people_num }}</td>
            <td>{{ item.qualified_people_num }}</td>
            <td>{{ item.number_of_paid }}</td>
            <td class="item_href">
              <div v-if="isLogin==false" @click="toLogin()">请前往首页注册或登录</div>
              <div v-else-if="item.is_sign_up==0" @click="signup(item.id)">报名</div>
              <div v-else-if="item.is_sign_up==1" @click="toStep(item.id)">查看</div>
            </td>
          </tr>
        </table>
        <div :class="['block', { hide: isPageHide }]">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :currentPage="currentPage"
            :page-size="pageSize"
            layout="prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Head from "./Head";
import Footer from "./Footer";
export default {
  props: {},
  data() {
    return {
      list: [],
      currentPage: 1,
      pageSize: 15,
      total: 0,
      isPageHide: 0,
      isLogin: false,
    };
  },
  computed: {},
  created() {},
  mounted() {
    if (localStorage.getItem("authorization")){
      this.isLogin=true
    }
    this.getList(1);
  },
  watch: {},
  methods: {
    dj() {
      alert("ssss");
    },
    //
    giveTo() {
      this.$router.push("/article");
    },
    toLogin(){
      this.$router.push("/");
    },
    signup(id) {
      this.$router.push("/enroll?post_id=" + id);
    },
    toStep(id) {
      this.$router.push("/step?post_id=" + id);
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.getList(val);
    },
    getList(pageid) {
      let _this = this;
      _this.request("api/post/list", { page: pageid }, "get").then((res) => {
        if (res.data.status == "success") {
          _this.list = res.data.data.data;
          _this.currentPage = res.data.data.current_page;
          _this.total = res.data.data.total;
          _this.pageSize = res.data.data.per_page;
          if (res.data.data.data.length==0) {
            _this.isPageHide = 1;
          }
        }
      });
    },
  },
  components: {
    Head,
    Footer,
  },
};
</script>

<style lang="less" scoped>
.number {
  h3 {
    font-size: 0.5rem;
    color: #00a0e9;
    text-align: center;
    padding: 0.3rem 0;
    margin-top: 0.7rem;
  }
  .number_box {
    text-align: center;
    width: 100%;
    margin-bottom: 1rem;
    table {
      width: 90%;
      margin-left: 50%;
      transform: translateX(-50%);
      border-collapse: collapse;
      tr {
        font-size: 0.33rem;
        border-bottom: #5b9bd5 2px solid;
        th {
          background-color: #5b9bd5;
          border: none;
          padding: 0.15rem 0;
          color: #fff;
        }
        th:nth-of-type(1) {
          width: 4rem;
        }
        td {
          border: 1px solid rgb(63, 63, 63);
          padding: 0.15rem 0;
        }
        .td_gg {
          width: 4rem;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .item_href {
          display: flex;
          flex-direction: column;
          border: none;
          cursor: pointer;
        }
        .item_href > div:hover {
          color: #5b9bd5;
        }
      }
    }
    .block {
      .el-pagination {
        margin-top: 1rem;
        button {
          i {
            width: 0.33rem;
          }
        }
        .el-pager {
          li {
            font-size: 0.33rem;
          }
        }
      }
    }
  }
}
.hide {
  display: none;
}
.number{
  min-height: calc(100vh - 7.65rem);
}
</style>
